import {
  DetailSectionConfig,
  PlaybookTrackerFilters,
  PlaybookTrackerSearchFilters,
} from './types';

export type PlaybookTrackerEnvOption = {
  name: string;
  url: string;
};

export const DEFAULT_PLAYBOOK_TRACKER_ENV_URL =
  'https://staging.lms.getvymo.com';

export const DEFAULT_PLAYBOOK_TRACKER_ENV_NAME = 'staging';

export const envUrls: PlaybookTrackerEnvOption[] = [
  {
    name: 'staging',
    url: DEFAULT_PLAYBOOK_TRACKER_ENV_URL,
  },
  {
    name: 'abcapital-prod',
    url: 'https://abcapital.lms.getvymo.com',
  },
  {
    name: 'maxlife-prod',
    url: 'https://axismaxlifeinsurance.lms.getvymo.com',
  },
];

export const STATUS_OPTIONS = [
  { label: 'FAILURE', value: 'FAILURE' },
  { label: 'SUCCESS', value: 'SUCCESS' },
  { label: 'PENDING', value: 'PENDING' },
];

export const PAGE_SIZE = 50;

export const DEFAULT_DATE_RANGE: [Date, Date] = [
  new Date(Date.now() - 7 * 24 * 60 * 60 * 1000),
  new Date(),
];

export const INITIAL_FILTERS: PlaybookTrackerFilters = {
  env: DEFAULT_PLAYBOOK_TRACKER_ENV_URL,
  envLabel: DEFAULT_PLAYBOOK_TRACKER_ENV_NAME,
  clientId: '',
  recordId: '',
  playbookCode: '',
  status: '',
  dateRange: DEFAULT_DATE_RANGE,
};

export const toSearchFilters = (
  filters: PlaybookTrackerFilters,
): PlaybookTrackerSearchFilters => ({
  host: filters.env || undefined,
  clientId: filters.clientId || undefined,
  recordId: filters.recordId || undefined,
  playbookCode: filters.playbookCode || undefined,
  status: filters.status || undefined,
  startDate: filters.dateRange?.[0] ?? undefined,
  endDate: filters.dateRange?.[1] ?? undefined,
});

export const getPayloadLines = (value: string) =>
  Math.min(Math.max(value.split('\n').length, 6), 18);

export const DETAIL_SECTIONS: DetailSectionConfig[] = [
  {
    title: 'Basic Info',
    fields: [
      { key: 'clientId', label: 'Client' },
      { key: 'type', label: 'Type' },
    ],
  },
  {
    title: 'Execution',
    fields: [
      { key: 'executionId', label: 'Execution ID' },
      { key: 'jobId', label: 'Job ID' },
      { key: 'ruleId', label: 'Rule ID' },
      { key: 'ruleActionId', label: 'Action ID' },
      { key: 'recordId', label: 'Record ID' },
    ],
  },
  {
    title: 'Timestamps',
    fields: [
      { key: 'createdAtLabel', label: 'Created' },
      { key: 'updatedAtLabel', label: 'Updated' },
    ],
  },
];
